// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_na-0";
export var animationContainer = "_na-1";
export var itemPrice = "_na-a";
export var itemizedContent = "_na-9";
export var itemizedHeader = "_na-7";
export var itemizedRow = "_na-8";
export var itemizedSection = "_na-6";
export var modalContent = "_na-2";
export var orderName = "_na-3";
export var refundOption = "_na-4";
export var refundOptionsContainer = "_na-5";
export var shippingLabel = "_na-b";
export var totalRow = "_na-c";